import { gql } from '@apollo/client';

export const GET_ACTIVITIES = gql`
  query MyQuery($mobileHero:Boolean!) {
    getMyActivity(mobileHero:$mobileHero){
        agId
        sd
        ed
        apSd
        apEd
        exSd
        exEd
        category
        store
        status
        errMsg
        opt
        alwaysOpen
        async
        startsOn
        endsOn
        heroPlaylist {
            autoPlay
            expires
            id
            mediaUrl
            mobileHero
            published
            assets {
              assetId
              basename
              description
              hlsPlaylistUrl
              mimeType
              mp4Url
              thumbnailUrl
              type
              url
              webmUrl
            }
          }
        eslug
        eid
        ename
        sid
        sname
        aid
        aname
        awgt
      }
  }
`;
